<aside
  class="sidebar"
  [class.sidebar--suppress-expand]="suppressExpand()"
  [class.sidebar--guest-minimal]="guestMinimalSidebar()"
  (mouseleave)="onSidebarMouseLeave()"
>
  <div class="sidebar-logo">
    @if (guestMinimalSidebar()) {
      <a routerLink="/" class="sidebar-logo__link" aria-label="Givo início">
        <img class="logo-compact" src="/icons/givo-icon-orange.svg" alt="" width="48" height="48" />
        <img class="logo-wide" src="/images/givo-logo-white.png" alt="" width="108" height="36" />
      </a>
    } @else {
      <img class="logo-compact" src="/icons/givo-icon-orange.svg" alt="Givo" width="48" height="48" />
      <img class="logo-wide" src="/images/givo-logo-white.png" alt="Givo" width="108" height="36" />
    }
  </div>
  @if (!guestMinimalSidebar()) {
    <nav class="sidebar-nav">
      @for (item of navItems(); track item.route) {
        <a
          [routerLink]="item.route"
          routerLinkActive="active"
          [routerLinkActiveOptions]="item.exact ? { exact: true } : { exact: false }"
          class="nav-item"
          [class.nav-item-avatar]="item.icon === 'avatar'"
          (click)="onNavItemClick()"
        >
          @switch (item.icon) {
          @case ('avatar') {
            @if (userAvatar().profilePictureUrl) {
              <img class="nav-avatar nav-avatar-img" [src]="userAvatar().profilePictureUrl" alt="" />
            } @else {
              <span class="nav-avatar">{{ userAvatar().name }}</span>
            }
          }
          @case ('list') {
            <svg class="nav-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
            </svg>
          }
          @case ('person') {
            <svg class="nav-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
          }
          @case ('people') {
            <svg
              class="nav-icon"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path d="M5 7a4 4 0 1 0 8 0a4 4 0 1 0-8 0" />
              <path d="M3 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              <path d="M21 21v-2a4 4 0 0 0-3-3.85" />
            </svg>
          }
          @case ('reservados') {
            <svg class="nav-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.709 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.85999M22 3.99999L12 14.01L9.00001 11.01"
              />
            </svg>
          }
          @case ('lightbulb') {
            <svg class="nav-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
            </svg>
          }
          @case ('gear') {
            <svg class="nav-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
              <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          }
          @case ('home') {
            <svg class="nav-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
          }
          @case ('admin-admins') {
            <svg
              class="nav-icon"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="1.75"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0-8 0" />
              <path d="M6 21v-2a4 4 0 0 1 4-4h2.5" />
              <path d="M17.001 19a2 2 0 1 0 4 0a2 2 0 1 0-4 0" />
              <path d="M19.001 15.5v1.5" />
              <path d="M19.001 21v1.5" />
              <path d="M22.032 17.25l-1.299.75" />
              <path d="M17.27 20l-1.3.75" />
              <path d="M15.97 17.25l1.3.75" />
              <path d="M20.733 20l1.3.75" />
            </svg>
          }
          @case ('admin-store') {
            <svg
              class="nav-icon"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="1.75"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path d="M3 21h18" />
              <path d="M3 7v1a3 3 0 0 0 6 0V7m0 1a3 3 0 0 0 6 0V7m0 1a3 3 0 0 0 6 0V7H3l2-4h14l2 4" />
              <path d="M5 21V10.85" />
              <path d="M19 21V10.85" />
              <path d="M9 21v-4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4" />
            </svg>
          }
          @case ('admin-flag') {
            <svg
              class="nav-icon"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="1.75"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path d="M5 5a5 5 0 0 1 7 0a5 5 0 0 0 7 0v9a5 5 0 0 1-7 0a5 5 0 0 0-7 0v-9" />
              <path d="M5 21v-7" />
            </svg>
          }
          }
          <span class="nav-label">{{ item.label }}</span>
        </a>
      }
    </nav>
  }
  @if (!guestMinimalSidebar()) {
    <div class="sidebar-footer">
      @if (showThemeToggle()) {
        <button
          type="button"
          class="btn-logout btn-theme"
          role="switch"
          [attr.aria-checked]="!isDarkTheme()"
          [attr.aria-label]="isDarkTheme() ? 'Ativar tema claro' : 'Ativar tema escuro'"
          (click)="toggleTheme()"
        >
          @if (isDarkTheme()) {
            <svg class="nav-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
            </svg>
            <span class="nav-label">Tema claro</span>
          } @else {
            <svg class="nav-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <circle cx="12" cy="12" r="4" />
              <path stroke-linecap="round" d="M12 3v2m0 14v2M3 12h2m14 0h2M5.6 5.6l1.4 1.4m10 10l1.4 1.4m0-12.8l-1.4 1.4m-10 10l-1.4 1.4" />
            </svg>
            <span class="nav-label">Tema escuro</span>
          }
        </button>
      }
      <button type="button" class="btn-logout" (click)="onNavItemClick(); onLogoutClick()">
        <svg class="nav-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
        </svg>
        <span class="nav-label">Sair</span>
      </button>
    </div>
  }
</aside>
